import { createContext, useContext } from "react";

export enum SectionStatus {
    LOADING = "loading",
    READY = "ready",
    ERROR = "error",
    EMPTY = "empty",
}

interface NonBrandedContextType {
    selectedRegion: string | null;
    setSelectedRegion: (region: string) => void;
}

const NonBrandedContext = createContext<NonBrandedContextType>({
    selectedRegion: null,
    setSelectedRegion: () => {},
})

export const useNonBrandedContext = () => {
    return useContext(NonBrandedContext);
}

export default function NonBrandedProvider({ children, values }: { children: React.ReactNode, values: NonBrandedContextType }) {
    return (
        <NonBrandedContext.Provider value={values}>{children}</NonBrandedContext.Provider>
    );
}